import { Field } from "formik";
import { registerWidget } from "./registry";
import { getClassName } from "./utils";

export const dateFormField = (config: any, formikParams: any) => {
  const extraProps = config ?? {};
  if (formikParams.handleChange != null)
    extraProps["onChange"] = formikParams.handleChange;
  return (
    <Field
      {...extraProps}
      key={config.key ?? config.name}
      name={config.name}
      type={config.type}
      style={{ ...config.style, marginBottom: "8px" }}
      className={getClassName(config)}
    />
  );
};

registerWidget("date", dateFormField);
